import type { PricingContent } from "../types";

export const pricing: PricingContent = {
  title: "A catalog that keeps up with the frontier.",
  lead:
    "Leading open-weight models served in Denmark, and the catalog grows " +
    "as the state of the art does, with new models added continuously. " +
    "Accounted in credits on the national UCloud platform. " +
    "No foreign invoices, no per-token payments abroad.",
  tableHeaders: [
    "Model",
    "Best for",
    "Context",
    "Credits / 1M in",
    "Credits / 1M out",
    "Credits / 1M cached",
  ],
  models: [
    { bestFor: "Complex reasoning, analysis, and agentic work" },
    { bestFor: "Multimodal, high-volume, and latency-sensitive tasks" },
  ],
  note:
    "For most workloads, GLM 5.3-Flash offers the best value; scale up to GLM 5.3 for complex reasoning. Rates shown in credits per 1M tokens. The catalog grows continuously: new state-of-the-art open-weight models arrive as they are released, and Danish models from Danish Foundation Models, trained on UCloud with national support, are on the way. Your data never trains any of them.",
};
